/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Not_An_AdministratorInputs */

const en_us2_club_not_an_administrator = /** @type {(inputs: Club_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the club's admins can do that.`)
};

const pt_br2_club_not_an_administrator = /** @type {(inputs: Club_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só os admins do clube podem fazer isso.`)
};

const es_419_club_not_an_administrator = /** @type {(inputs: Club_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo los admins del club pueden hacer eso.`)
};

const pt_pt2_club_not_an_administrator = /** @type {(inputs: Club_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só os admins do clube podem fazer isso.`)
};

const fr_fr2_club_not_an_administrator = /** @type {(inputs: Club_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuls les admins du club peuvent faire ça.`)
};

const de_de2_club_not_an_administrator = /** @type {(inputs: Club_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das können nur die Admins des Clubs.`)
};

const it_it2_club_not_an_administrator = /** @type {(inputs: Club_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo gli admin del club possono farlo.`)
};

/**
* | output |
* | --- |
* | "Only the club's admins can do that." |
*
* @param {Club_Not_An_AdministratorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_not_an_administrator = /** @type {((inputs?: Club_Not_An_AdministratorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Not_An_AdministratorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_not_an_administrator(inputs)
	if (locale === "es-419") return es_419_club_not_an_administrator(inputs)
	if (locale === "pt-PT") return pt_pt2_club_not_an_administrator(inputs)
	if (locale === "fr-FR") return fr_fr2_club_not_an_administrator(inputs)
	if (locale === "de-DE") return de_de2_club_not_an_administrator(inputs)
	if (locale === "it-IT") return it_it2_club_not_an_administrator(inputs)
	return en_us2_club_not_an_administrator(inputs)
});
export { club_not_an_administrator as "club.not_an_administrator" }